import React from 'react';
import { BarChart, DollarSign, TrendingUp } from 'lucide-react';

export default function DealAnalytics() {
  return (
    <div className="bg-white p-6 rounded-lg shadow-sm mb-6">
      <h3 className="text-lg font-medium text-gray-900 mb-4">Pipeline Analytics</h3>
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="p-4 bg-blue-50 rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-sm font-medium text-blue-900">Win Rate</h4>
            <TrendingUp className="w-5 h-5 text-blue-600" />
          </div>
          <p className="text-2xl font-bold text-blue-900">75%</p>
          <p className="text-sm text-blue-700">+5% vs last quarter</p>
        </div>
        
        <div className="p-4 bg-green-50 rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-sm font-medium text-green-900">Average Deal Time</h4>
            <BarChart className="w-5 h-5 text-green-600" />
          </div>
          <p className="text-2xl font-bold text-green-900">45 days</p>
          <p className="text-sm text-green-700">-3 days vs average</p>
        </div>
        
        <div className="p-4 bg-purple-50 rounded-lg">
          <div className="flex items-center justify-between mb-2">
            <h4 className="text-sm font-medium text-purple-900">Pipeline Value</h4>
            <DollarSign className="w-5 h-5 text-purple-600" />
          </div>
          <p className="text-2xl font-bold text-purple-900">$2.4B</p>
          <p className="text-sm text-purple-700">+15% vs last month</p>
        </div>
      </div>
    </div>
  );
}